import { i18nData } from './i18n.js';

// Base language is strictly Spanish ('es')
let currentLang = 'es';

// Check URL param or saved user preference
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('lang') === 'en' || (!urlParams.has('lang') && localStorage.getItem('st24_lang') === 'en')) {
  currentLang = 'en';
}

// Safe DOM Helper Functions
const safeSetText = (id, val) => {
  const el = document.getElementById(id);
  if (el && val !== undefined && val !== null) el.textContent = val;
};

const safeSetHTML = (id, val) => {
  const el = document.getElementById(id);
  if (el && val !== undefined && val !== null) el.innerHTML = val;
};

const safeSetAttr = (id, attr, val) => {
  const el = document.getElementById(id);
  if (el && val !== undefined && val !== null) el.setAttribute(attr, val);
};

const safeQuerySetText = (sel, val) => {
  const el = document.querySelector(sel);
  if (el && val !== undefined && val !== null) el.textContent = val;
};

const safeQuerySetHTML = (sel, val) => {
  const el = document.querySelector(sel);
  if (el && val !== undefined && val !== null) el.innerHTML = val;
};

function setLanguage(lang) {
  if (lang !== 'es' && lang !== 'en') return;
  currentLang = lang;
  localStorage.setItem('st24_lang', lang);
  
  // Clean URL manipulation without reload
  const newUrl = new URL(window.location);
  if (lang === 'en') {
    newUrl.searchParams.set('lang', 'en');
  } else {
    newUrl.searchParams.delete('lang');
  }
  window.history.replaceState({}, '', newUrl);

  renderApp();
}

function renderApp() {
  const t = i18nData[currentLang];
  const isEs = currentLang === 'es';

  // 1. Document & Metadata
  const currentPath = window.location.pathname.toLowerCase();
  
  if (currentPath.includes('quienes-somos') || currentPath.includes('about-us')) {
    document.title = isEs ? '¿Quiénes Somos? | Salo Trading 24 - Historia y Valores' : 'About Us | Salo Trading 24 - History & Core Values';
  } else if (currentPath.includes('sectores') || currentPath.includes('sectors')) {
    document.title = isEs ? 'Sectores de Negocio | Salo Trading 24 - Comercio Internacional' : 'Business Sectors | Salo Trading 24 - International Trade';
  } else if (currentPath.includes('proveedores') || currentPath.includes('suppliers')) {
    document.title = isEs ? 'Nuestros Proveedores y Marcas | Salo Trading 24' : 'Our Suppliers & Brand Network | Salo Trading 24';
  } else if (currentPath.includes('blog') || currentPath.includes('publicaciones')) {
    document.title = isEs ? 'Publicaciones e Inteligencia Comercial | Salo Trading 24' : 'Publications & Market Intelligence | Salo Trading 24';
  } else if (currentPath.includes('novedades-de-la-ces-2021') || currentPath.includes('whats-new-at-ces-2021')) {
    document.title = isEs ? 'Novedades de la CES 2021 | Salo Trading 24 - Análisis Completo' : "What's New at CES 2021 | Salo Trading 24 - Full Tech Report";
  } else if (currentPath.includes('contacto') || currentPath.includes('contact')) {
    document.title = isEs ? 'Contacto y Sedes | Salo Trading 24 - Caracas & Miami' : 'Contact & Headquarters | Salo Trading 24 - Caracas & Miami';
  } else {
    document.title = t.meta.title;
  }

  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc) metaDesc.setAttribute('content', t.meta.description);
  document.documentElement.lang = currentLang;

  // 2. Dual-Pill Language Buttons Sync
  document.querySelectorAll('.lang-toggle-group').forEach(group => {
    group.querySelectorAll('.lang-btn').forEach(btn => {
      const btnLang = btn.getAttribute('data-lang');
      if (btnLang === currentLang) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  });

  // 3. Top Notification Bar
  safeSetText('top-phone', t.topbar.phone);
  safeSetText('top-email', t.topbar.email);
  safeSetHTML('top-hq-badge', `<i class="fa-solid fa-location-dot"></i> ${t.topbar.hqBadge}`);
  safeSetHTML('top-schedule', `<i class="fa-regular fa-clock"></i> ${t.topbar.schedule}`);
  safeSetHTML('top-corp-badge', `<span class="pulse-dot-gold"></span> ${t.topbar.corpBadge}`);

  // 4. Navigation Menu & Actions
  safeSetText('nav-cta-text', t.topbar.navCta || t.hero.ctaPrimary);
  document.querySelectorAll('.mobile-drawer-cta-text').forEach(el => {
    el.textContent = t.topbar.navCta || t.hero.ctaPrimary;
  });
  document.querySelectorAll('[data-nav]').forEach(el => {
    const key = el.getAttribute('data-nav');
    if (t.nav[key]) {
      const textSpan = el.querySelector('.nav-text');
      if (textSpan) {
        textSpan.textContent = t.nav[key];
      } else if (el.querySelector('i')) {
        const icon = el.querySelector('i');
        el.childNodes.forEach(child => {
          if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
            child.textContent = t.nav[key] + ' ';
          }
        });
      } else {
        el.textContent = t.nav[key];
      }
    }
  });

  // Nav Mega-Flyouts Translation
  safeSetText('flyout-about-badge', t.nav.flyoutAboutBadge);
  safeSetText('flyout-about-meta', t.nav.flyoutAboutMeta);
  safeSetText('flyout-history-title', t.nav.flyoutHistoryTitle);
  safeSetText('flyout-history-desc', t.nav.flyoutHistoryDesc);
  safeSetText('flyout-struct-title', t.nav.flyoutStructTitle);
  safeSetText('flyout-struct-desc', t.nav.flyoutStructDesc);
  safeSetText('flyout-csr-title', t.nav.flyoutCsrTitle);
  safeSetText('flyout-csr-desc', t.nav.flyoutCsrDesc);
  safeSetText('flyout-hqs-title', t.nav.flyoutHqsTitle);
  safeSetText('flyout-hqs-desc', t.nav.flyoutHqsDesc);

  safeSetText('flyout-sectors-badge', t.nav.flyoutSectorsBadge);
  safeSetText('flyout-sectors-meta', t.nav.flyoutSectorsMeta);
  safeQuerySetText('#flyout-chip-food span', t.nav.flyoutFood);
  safeQuerySetText('#flyout-chip-health span', t.nav.flyoutHealth);
  safeQuerySetText('#flyout-chip-sports span', t.nav.flyoutSports);
  safeQuerySetText('#flyout-chip-logistics span', t.nav.flyoutLogistics);
  safeQuerySetText('#flyout-chip-hardware span', t.nav.flyoutHardware);
  safeQuerySetText('#flyout-chip-services span', t.nav.flyoutServices);
  safeQuerySetText('#flyout-chip-tech span', t.nav.flyoutTech);

  // Sync Sliding Language Pills
  document.querySelectorAll('.lang-toggle-group').forEach(group => {
    const slider = group.querySelector('.lang-slider-pill');
    if (slider) {
      if (currentLang === 'en') {
        slider.style.transform = 'translateX(100%)';
      } else {
        slider.style.transform = 'translateX(0)';
      }
    }
  });

  // Highlight Current Page Nav Link
  document.querySelectorAll('.nav-menu-links a, .mobile-drawer-menu a').forEach(link => {
    const href = link.getAttribute('href');
    if (href && !href.startsWith('#')) {
      if (window.location.pathname.endsWith(href) || (href === '/' && (window.location.pathname === '/' || window.location.pathname.endsWith('index.html')))) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    }
  });

  // 5. Hero Section (Home page)
  safeQuerySetText('#hero-badge span', t.hero.badge);
  safeSetText('hero-headline-prefix', t.hero.headlinePrefix);
  safeSetText('hero-headline-highlight', t.hero.headlineHighlight);
  safeSetText('hero-subheadline', t.hero.subheadline);
  safeQuerySetText('#hero-cta-primary span', t.hero.ctaPrimary);
  safeQuerySetText('#hero-cta-secondary span', t.hero.ctaSecondary);
  safeSetText('hero-map-title', t.hero.mapTitle);
  safeSetText('hero-map-sub', t.hero.mapSub);

  // Stats Counters
  if (t.hero && t.hero.stats) {
    t.hero.stats.forEach((st, idx) => {
      safeSetText(`stat-val-${idx}`, st.value);
      safeSetText(`stat-lbl-${idx}`, st.label);
      safeSetText(`stat-sub-${idx}`, st.sub);
    });
  }

  // Default Map HUD Node
  if (t.hero && t.hero.nodes && t.hero.nodes.caracas) {
    const defaultNode = t.hero.nodes.caracas;
    safeSetText('map-hud-name', defaultNode.name);
    safeSetText('map-hud-desc', defaultNode.desc);
  }

  // 6. About Us Section (Home & Dedicated Page)
  safeQuerySetText('#about-badge span', t.about.badge);
  safeSetText('about-title', t.about.title);
  safeSetText('about-locations-desc', t.about.locationsDesc);
  
  const leadHTML = isEs
    ? `<strong>SALO TRADING 24</strong> comienza sus operaciones en el año 2009, cuando nuestro Presidente, <span class="founder-pill"><i class="fa-solid fa-user-tie"></i> Menahem Truzman</span>, funda la organización con el objetivo de comercializar todo tipo de productos en los sectores alimenticio, servicios, salud, deportes, transporte, ferretería y otros, todos de lícito comercio.`
    : `<strong>SALO TRADING 24</strong> began its operations in 2009, when our President, <span class="founder-pill"><i class="fa-solid fa-user-tie"></i> Menahem Truzman</span>, founded the organization with the aim of commercializing all kinds of products in the food, services, health, sports, transportation, hardware and other sectors, all of legal trade.`;
  safeSetHTML('about-lead', leadHTML);

  safeSetText('mission-title', t.about.missionTitle);
  safeSetText('mission-desc', t.about.missionDesc);
  safeSetText('vision-title', t.about.visionTitle);
  safeSetText('vision-desc', t.about.visionDesc);
  safeSetText('values-title', t.about.valuesTitle);

  // Values Render
  const valuesContainer = document.getElementById('values-container');
  if (valuesContainer && t.about && t.about.values) {
    valuesContainer.innerHTML = t.about.values.map(v => `
      <div class="value-item-card">
        <div class="value-title"><i class="fa-solid fa-shield-check" style="color: var(--color-gold-400);"></i> ${v.title}</div>
        <div class="value-desc">${v.desc}</div>
      </div>
    `).join('');
  }

  // Headquarters Details
  safeSetHTML('hq-caracas-badge', `<i class="fa-solid fa-flag"></i> ${t.about.hqCard.badge}`);
  safeSetText('hq-caracas-title', t.about.hqCard.title);
  safeSetText('hq-caracas-address', t.about.hqCard.address);
  safeSetHTML('hq-caracas-base', `<strong>${isEs ? 'Base de Distribución:' : 'Distribution Base:'}</strong> ${t.about.hqCard.base.split(': ')[1] || t.about.hqCard.base}`);

  safeSetHTML('hq-miami-badge', `<i class="fa-solid fa-earth-americas"></i> ${t.about.miamiCard.badge}`);
  safeSetText('hq-miami-title', t.about.miamiCard.title);
  safeSetText('hq-miami-address', t.about.miamiCard.address);
  safeSetHTML('hq-miami-base', `<strong>${isEs ? 'Aliados en Norteamérica:' : 'North American Allies:'}</strong> ${t.about.miamiCard.base.split(': ')[1] || t.about.miamiCard.base}`);

  // 7. Organizational Structure
  safeQuerySetText('#structure-badge span', t.structure.badge);
  safeSetText('structure-title', t.structure.title);
  safeSetText('structure-subtitle', t.structure.subtitle);
  safeSetHTML('org-modal-prompt', `<i class="fa-solid fa-hand-pointer"></i> ${t.structure.modalPrompt}`);

  safeSetText('org-pres-badge', t.structure.president.badge);
  safeSetText('org-pres-name', t.structure.president.name);
  safeSetText('org-pres-role', t.structure.president.role);
  safeSetText('org-pres-desc', t.structure.president.desc);

  safeSetText('org-asst-role', t.structure.assistant.role);
  safeSetText('org-asst-desc', t.structure.assistant.desc);

  const deptsContainer = document.getElementById('org-departments-row');
  if (deptsContainer && t.structure && t.structure.departments) {
    deptsContainer.innerHTML = t.structure.departments.map((d, i) => `
      <div class="org-dept-card" data-dept-idx="${i}">
        <div class="org-dept-icon">
          <i class="fa-solid ${i === 0 ? 'fa-cart-shopping' : i === 1 ? 'fa-arrow-trend-up' : 'fa-calculator'}"></i>
        </div>
        <div class="org-dept-title">${d.title}</div>
        <div class="org-dept-desc">${d.desc}</div>
        <div style="font-size: 0.72rem; color: var(--color-gold-400); margin-top: 0.75rem; font-weight: 700;">
          <i class="fa-solid fa-circle-info"></i> ${isEs ? 'Ver Responsabilidades' : 'View Scope'}
        </div>
      </div>
    `).join('');
  }

  // 8. Corporate Social Responsibility (CSR)
  safeQuerySetText('#csr-badge span', t.csr.badge);
  safeSetText('csr-title', t.csr.title);
  safeSetText('csr-lead', t.csr.lead);

  const pyramidContainer = document.getElementById('pyramid-container');
  if (pyramidContainer && t.csr && t.csr.pyramidLevels) {
    const widthMap = { 5: '55%', 4: '66%', 3: '77%', 2: '88%', 1: '100%' };
    pyramidContainer.innerHTML = t.csr.pyramidLevels.map(lvl => `
      <button class="pyramid-tier-btn ${lvl.level === 5 ? 'active' : ''}" 
              data-level="${lvl.level}" 
              style="--tier-width: ${widthMap[lvl.level]}; --tier-bg: ${lvl.color}22; border-left: 4px solid ${lvl.color};">
        <span class="pyramid-tier-title">${lvl.name}</span>
        <span class="pyramid-tier-badge" style="background: ${lvl.color}; color: #040826;">${isEs ? 'Nivel' : 'Level'} ${lvl.level}</span>
      </button>
    `).join('');

    const topLvl = t.csr.pyramidLevels[0];
    safeSetText('csr-active-tier', topLvl.tier);
    safeSetText('csr-active-indicator', `${isEs ? 'NIVEL' : 'LEVEL'} ${topLvl.level} / 5`);
    safeSetText('csr-active-name', topLvl.name);
    safeSetText('csr-active-desc', topLvl.desc);
  }

  const csrPillarsGrid = document.getElementById('csr-pillars-grid');
  if (csrPillarsGrid && t.csr && t.csr.focusAreas) {
    csrPillarsGrid.innerHTML = t.csr.focusAreas.map(fa => `
      <div class="csr-pillar-item">
        <div style="color: var(--color-gold-400); font-size: 1.5rem; margin-bottom: 0.75rem;">
          <i class="fa-solid ${fa.icon === 'leaf' ? 'fa-leaf' : fa.icon === 'users' ? 'fa-users' : 'fa-lightbulb'}"></i>
        </div>
        <div class="csr-pillar-title">${fa.title}</div>
        <div class="csr-pillar-desc">${fa.desc}</div>
      </div>
    `).join('');
  }

  // 9. Sectors
  safeQuerySetText('#sectors-badge span', t.sectors.badge);
  safeSetText('sectors-title', t.sectors.title);
  safeSetText('sectors-subtitle', t.sectors.subtitle);

  const sectorsGrid = document.getElementById('sectors-grid');
  if (sectorsGrid && t.sectors && t.sectors.items) {
    const sectorIcons = {
      'shopping-bag': 'fa-basket-shopping',
      'heart-pulse': 'fa-heart-pulse',
      'trophy': 'fa-medal',
      'truck': 'fa-truck-fast',
      'wrench': 'fa-screwdriver-wrench',
      'briefcase': 'fa-briefcase',
      'tv': 'fa-microchip'
    };

    sectorsGrid.innerHTML = t.sectors.items.map(s => `
      <div class="sector-card">
        <div>
          <div class="sector-code">SECTOR // ${s.code}</div>
          <div class="sector-icon">
            <i class="fa-solid ${sectorIcons[s.icon] || 'fa-box'}"></i>
          </div>
          <div class="sector-name">${s.name}</div>
          <div class="sector-desc">${s.desc}</div>
        </div>
        <div style="margin-top: 1.5rem; padding-top: 1rem; border-top: 1px solid rgba(255,255,255,0.06); font-size: 0.78rem; color: var(--color-gold-400); font-weight: 700;">
          <i class="fa-solid fa-certificate"></i> ${t.sectors.verifiedBadge}
        </div>
      </div>
    `).join('');
  }

  // 10. Markets
  safeQuerySetText('#markets-badge span', t.markets.badge);
  safeSetText('markets-title', t.markets.title);
  safeSetText('markets-subtitle', t.markets.subtitle);
  safeSetText('markets-allies-north-title', t.markets.alliesNorthAmericaTitle);
  safeSetText('markets-allies-north-desc', t.markets.alliesNorthAmericaDesc);
  safeSetText('markets-south-america-title', t.markets.southAmericaTitle);
  safeSetText('markets-south-america-desc', t.markets.southAmericaDesc);
  safeSetText('routes-badge-north', t.markets.routesBadgeNorth);
  safeSetText('routes-badge-south', t.markets.routesBadgeSouth);

  const regionsGrid = document.getElementById('regions-grid');
  if (regionsGrid && t.markets && t.markets.regions) {
    regionsGrid.innerHTML = t.markets.regions.map(r => `
      <div class="region-tile">
        <div class="region-tile-code">REGION // ${r.code}</div>
        <div class="region-tile-name">${r.name}</div>
        <div class="region-tile-desc">${r.desc}</div>
      </div>
    `).join('');
  }

  // 11. Suppliers & Brand Marquee
  safeQuerySetText('#suppliers-badge span', t.suppliers.badge);
  safeSetText('suppliers-title', t.suppliers.title);
  
  const suppliersStatementHTML = isEs
    ? `Hemos mantenido relaciones comerciales exitosas con <strong>Duracell</strong> y con <strong>Gillette de Venezuela</strong>. Nuestro plan de expansión contempla ampliar estos vínculos, en ese sentido, iniciamos contacto con grandes comercializadoras locales e internacionales las cuales manejan productos de marcas como: Nestlé, Del Monte, Procter &amp; Gamble, Fuji, JBL, Nike, Adidas, Canon, Crayola, entre muchas otras.`
    : `We have had successful business relationships with <strong>Duracell</strong> and <strong>Gillette Venezuela</strong>. Our expansion plan includes expanding our network, in that sense, we initiate contact with large local and international marketers which handle products from brands such as: Nestlé, Del Monte, Procter &amp; Gamble, Fuji, JBL, Nike, Adidas, Canon, Crayola, among many others.`;
  safeSetHTML('suppliers-statement', suppliersStatementHTML);

  const marqueeTrack = document.getElementById('brand-marquee-track');
  if (marqueeTrack && t.suppliers && t.suppliers.allBrands) {
    const doubleBrands = [...t.suppliers.allBrands, ...t.suppliers.allBrands];
    marqueeTrack.innerHTML = doubleBrands.map(b => `
      <div class="brand-marquee-item"><i class="fa-solid fa-star" style="color: var(--color-gold-400); font-size: 0.65rem; margin-right: 0.4rem;"></i> ${b}</div>
    `).join('');
  }

  const brandsCloud = document.getElementById('brands-cloud');
  if (brandsCloud && t.suppliers && t.suppliers.allBrands) {
    brandsCloud.innerHTML = t.suppliers.allBrands.map(b => `
      <span class="brand-pill">${b}</span>
    `).join('');
  }

  // 12. Blog & Publications (CES 2021)
  safeQuerySetText('#blog-badge span', t.blog.badge);
  safeSetText('blog-title', t.blog.title);
  safeSetText('blog-subtitle', t.blog.subtitle);
  safeSetText('post-cat-badge', t.blog.categoryTag);
  safeSetText('post-date', t.blog.post.date);
  safeSetText('post-title', t.blog.post.title);
  safeSetText('post-intro-1', t.blog.post.introP1);
  safeSetText('post-intro-2', t.blog.post.introP2);
  safeSetText('post-subheading', t.blog.post.subheading);
  safeQuerySetText('#post-read-link span', t.blog.readArticle);

  // Render CES 2021 Brand Cards (Home preview + Full Article view)
  const cesGrid = document.getElementById('ces-brands-grid');
  if (cesGrid && t.blog && t.blog.post && t.blog.post.brandsList) {
    cesGrid.innerHTML = t.blog.post.brandsList.map((item, idx) => `
      <div class="article-brand-card" data-brand="${item.name.toLowerCase()}">
        <div class="article-brand-header">
          <div class="article-brand-name">${item.name}</div>
          <span class="article-brand-num">#${String(idx + 1).padStart(2, '0')}</span>
        </div>
        <div class="article-brand-desc">${item.desc}</div>
      </div>
    `).join('');
  }

  // 13. Contact Section
  safeQuerySetText('#contact-badge span', t.contact.badge);
  safeSetText('contact-title', t.contact.title);
  safeSetText('contact-subtitle', t.contact.subtitle);
  safeSetText('form-heading', t.contact.formTitle);
  safeSetText('label-name', t.contact.nameLabel);
  safeSetAttr('contact-name', 'placeholder', t.contact.namePlaceholder);
  safeSetText('label-email', t.contact.emailLabel);
  safeSetAttr('contact-email', 'placeholder', t.contact.emailPlaceholder);
  safeSetText('label-phone', t.contact.phoneLabel);
  safeSetAttr('contact-phone', 'placeholder', t.contact.phonePlaceholder);
  safeSetText('label-subject', t.contact.subjectLabel);
  safeSetText('label-message', t.contact.messageLabel);
  safeSetAttr('contact-message', 'placeholder', t.contact.messagePlaceholder);
  safeSetText('btn-submit-text', t.contact.submitBtn);

  const subjectSelect = document.getElementById('contact-subject');
  if (subjectSelect && t.contact && t.contact.subjectOptions) {
    subjectSelect.innerHTML = t.contact.subjectOptions.map(opt => `
      <option value="${opt}">${opt}</option>
    `).join('');
  }

  // Contact Office Cards
  safeSetText('card-hq-label', t.contact.cards.hqTitle);
  safeSetText('card-hq-val', t.contact.cards.hqAddress);
  safeSetHTML('card-maps-link', `<i class="fa-solid fa-location-arrow"></i> ${t.contact.cards.mapsLinkText}`);
  safeSetText('card-miami-label', t.contact.cards.miamiTitle);
  safeSetText('card-miami-val', t.contact.cards.miamiAddress);
  safeSetText('card-phone-label', t.contact.cards.phoneTitle);
  safeSetText('card-phone-val', t.contact.cards.phoneValue);
  safeSetText('card-email-label', t.contact.cards.emailTitle);
  safeSetText('card-email-val', t.contact.cards.emailValue);
  safeSetText('card-insta-label', t.contact.cards.instagramTitle);
  safeQuerySetText('#contact-whatsapp-btn span', t.contact.cards.whatsappBtn);
  safeSetText('floating-whatsapp-tooltip', t.contact.floatingWhatsApp);

  // 14. Sitemap Audit Section
  safeQuerySetText('#sitemap-badge span', t.sitemapAudit.badge);
  safeSetText('sitemap-title', t.sitemapAudit.title);
  safeSetText('sitemap-subtitle', t.sitemapAudit.subtitle);
  safeSetText('sitemap-legacy-title', t.sitemapAudit.legacyColTitle);
  safeSetText('sitemap-rectified-title', t.sitemapAudit.rectifiedColTitle);

  const legacyIssuesList = document.getElementById('sitemap-legacy-issues');
  if (legacyIssuesList && t.sitemapAudit && t.sitemapAudit.legacyIssues) {
    legacyIssuesList.innerHTML = t.sitemapAudit.legacyIssues.map(issue => `
      <li class="audit-issue-item">
        <i class="fa-solid fa-circle-xmark" style="color: #F87171; margin-top: 3px;"></i>
        <span>${issue}</span>
      </li>
    `).join('');
  }

  const rectifiedFeaturesList = document.getElementById('sitemap-rectified-features');
  if (rectifiedFeaturesList && t.sitemapAudit && t.sitemapAudit.rectifiedFeatures) {
    rectifiedFeaturesList.innerHTML = t.sitemapAudit.rectifiedFeatures.map(feat => `
      <li class="audit-issue-item">
        <i class="fa-solid fa-circle-check" style="color: #34D399; margin-top: 3px;"></i>
        <span>${feat}</span>
      </li>
    `).join('');
  }

  const tableBody = document.getElementById('sitemap-table-body');
  if (tableBody && t.sitemapAudit && t.sitemapAudit.table) {
    tableBody.innerHTML = t.sitemapAudit.table.map(row => `
      <tr>
        <td><span class="route-badge">${row.route}</span></td>
        <td>${row.descEs}</td>
        <td>${row.descEn}</td>
        <td style="font-family: var(--font-mono); font-weight: 700; color: var(--color-gold-400);">${row.priority}</td>
      </tr>
    `).join('');
  }

  safeSetHTML('btn-view-sitemap-xml', `<i class="fa-solid fa-file-code"></i> ${t.sitemapAudit.xmlBtn}`);
  safeSetHTML('btn-view-robots-txt', `<i class="fa-solid fa-robot"></i> ${t.sitemapAudit.robotsBtn}`);

  // 15. Footer
  safeSetText('footer-tagline', t.footer.tagline);
  safeSetText('footer-nav-title', t.footer.quickLinksTitle);
  safeSetText('footer-company-title', t.footer.companyTitle);
  safeSetText('footer-legal-title', t.footer.legalTitle);
  safeSetText('footer-legal-text', t.footer.legalText);
  safeSetHTML('footer-compliance-badge', `<i class="fa-solid fa-certificate"></i> ${t.footer.complianceBadge}`);
  safeSetText('footer-copyright', t.footer.copyright);
  safeSetText('footer-dev-credit', t.footer.devCredit);

  // Update Historic Scanned Diagrams based on current language
  const structImg = document.getElementById('original-structure-img');
  if (structImg) {
    structImg.src = isEs ? '/images/estructura.png' : '/images/STRUCTURE-2.png';
  }
  const policyImg = document.getElementById('original-policy-img');
  if (policyImg) {
    policyImg.src = isEs ? '/images/politicas.png' : '/images/piramidal2.png';
  }
}

// Global Handlers Initialization
document.addEventListener('DOMContentLoaded', () => {
  renderApp();

  // Instant Dual-Pill Language Handlers (Event Delegation)
  document.addEventListener('click', (e) => {
    const langBtn = e.target.closest('.lang-btn');
    if (langBtn) {
      const selectedLang = langBtn.getAttribute('data-lang');
      if (selectedLang) {
        setLanguage(selectedLang);
      }
    }
  });

  // Mobile Drawer Toggle
  const drawer = document.getElementById('mobile-drawer');
  document.getElementById('mobile-toggle')?.addEventListener('click', () => {
    drawer?.classList.add('active');
  });
  document.getElementById('mobile-close')?.addEventListener('click', () => {
    drawer?.classList.remove('active');
  });
  drawer?.querySelectorAll('.mobile-drawer-link').forEach(link => {
    link.addEventListener('click', () => {
      drawer.classList.remove('active');
    });
  });

  // Interactive World Trade Map Nodes (HUD Hover / Click)
  document.querySelectorAll('.map-node').forEach(node => {
    const handleNodeSelect = () => {
      const hubKey = node.getAttribute('data-hub');
      const t = i18nData[currentLang];
      if (hubKey && t.hero && t.hero.nodes && t.hero.nodes[hubKey]) {
        const hub = t.hero.nodes[hubKey];
        safeSetText('map-hud-name', hub.name);
        safeSetText('map-hud-desc', hub.desc);
      }
    };
    node.addEventListener('mouseenter', handleNodeSelect);
    node.addEventListener('click', handleNodeSelect);
  });

  // Interactive Pyramid Level Selection
  document.addEventListener('click', (e) => {
    const tierBtn = e.target.closest('.pyramid-tier-btn');
    if (tierBtn) {
      document.querySelectorAll('.pyramid-tier-btn').forEach(b => b.classList.remove('active'));
      tierBtn.classList.add('active');
      const lvlNum = parseInt(tierBtn.getAttribute('data-level'), 10);
      const t = i18nData[currentLang];
      if (t.csr && t.csr.pyramidLevels) {
        const lvlData = t.csr.pyramidLevels.find(l => l.level === lvlNum);
        if (lvlData) {
          safeSetText('csr-active-tier', lvlData.tier);
          safeSetText('csr-active-indicator', `${currentLang === 'es' ? 'NIVEL' : 'LEVEL'} ${lvlData.level} / 5`);
          safeSetText('csr-active-name', lvlData.name);
          safeSetText('csr-active-desc', lvlData.desc);
        }
      }
    }
  });

  // Executive Org Chart Modal
  const modal = document.getElementById('executive-modal');
  const modalBadge = document.getElementById('modal-role-badge');
  const modalTitle = document.getElementById('modal-role-title');
  const modalSubtitle = document.getElementById('modal-role-subtitle');
  const modalDesc = document.getElementById('modal-role-desc');
  const closeModalBtn = document.getElementById('modal-close-btn');

  const openOrgModal = (badge, title, subtitle, desc) => {
    if (modalBadge) modalBadge.textContent = badge;
    if (modalTitle) modalTitle.textContent = title;
    if (modalSubtitle) modalSubtitle.textContent = subtitle;
    if (modalDesc) modalDesc.textContent = desc;
    modal?.classList.add('active');
  };

  document.getElementById('org-pres-node')?.addEventListener('click', () => {
    const t = i18nData[currentLang];
    openOrgModal(t.structure.president.badge, t.structure.president.name, t.structure.president.role, t.structure.president.details);
  });

  document.getElementById('org-asst-node')?.addEventListener('click', () => {
    const t = i18nData[currentLang];
    openOrgModal('COORDINACIÓN EJECUTIVA', t.structure.assistant.role, 'Apoyo a la Presidencia', t.structure.assistant.details);
  });

  document.addEventListener('click', (e) => {
    const deptCard = e.target.closest('.org-dept-card');
    if (deptCard) {
      const idx = parseInt(deptCard.getAttribute('data-dept-idx'), 10);
      const t = i18nData[currentLang];
      if (t.structure && t.structure.departments) {
        const dept = t.structure.departments[idx];
        if (dept) {
          openOrgModal(`DIRECCIÓN // ${dept.role.toUpperCase()}`, dept.title, dept.role, dept.details);
        }
      }
    }
  });

  closeModalBtn?.addEventListener('click', () => modal?.classList.remove('active'));
  modal?.addEventListener('click', (e) => {
    if (e.target === modal) modal.classList.remove('active');
  });

  // Historical Compliance Image Archive Modal Handler
  const archiveModal = document.getElementById('archive-modal');
  const archiveModalImg = document.getElementById('archive-modal-img');
  const archiveModalTitle = document.getElementById('archive-modal-title');
  const archiveModalDesc = document.getElementById('archive-modal-desc');
  const closeArchiveModalBtn = document.getElementById('archive-modal-close-btn');

  document.addEventListener('click', (e) => {
    const inspectBtn = e.target.closest('[data-inspect-archive]');
    if (inspectBtn) {
      const imgSrc = inspectBtn.getAttribute('data-archive-src');
      const title = inspectBtn.getAttribute('data-archive-title');
      const desc = inspectBtn.getAttribute('data-archive-desc');
      if (archiveModalImg) archiveModalImg.src = imgSrc;
      if (archiveModalTitle) archiveModalTitle.textContent = title;
      if (archiveModalDesc) archiveModalDesc.textContent = desc;
      archiveModal?.classList.add('active');
    }
  });

  closeArchiveModalBtn?.addEventListener('click', () => archiveModal?.classList.remove('active'));
  archiveModal?.addEventListener('click', (e) => {
    if (e.target === archiveModal) archiveModal.classList.remove('active');
  });

  // CES 2021 Live Search Filter
  const cesSearchInput = document.getElementById('ces-search-input');
  cesSearchInput?.addEventListener('input', (e) => {
    const term = e.target.value.toLowerCase().trim();
    document.querySelectorAll('.article-brand-card').forEach(card => {
      const brand = card.getAttribute('data-brand') || '';
      const text = card.textContent.toLowerCase();
      if (!term || brand.includes(term) || text.includes(term)) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
  });

  // Contact Form Submission Handler
  const contactForm = document.getElementById('corporate-contact-form');
  const successBanner = document.getElementById('form-success-banner');
  const submitBtn = document.getElementById('form-submit-btn');

  contactForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const btnText = document.getElementById('btn-submit-text');
    const originalText = btnText ? btnText.textContent : 'Enviar';
    if (btnText) btnText.textContent = currentLang === 'es' ? 'Procesando envío...' : 'Processing...';
    if (submitBtn) submitBtn.disabled = true;

    setTimeout(() => {
      if (btnText) btnText.textContent = originalText;
      if (submitBtn) submitBtn.disabled = false;
      contactForm.reset();
      if (successBanner) {
        successBanner.style.display = 'block';
        setTimeout(() => {
          successBanner.style.display = 'none';
        }, 8000);
      }
    }, 800);
  });

  // ==========================================================================
  // 2026 TRENDSETTING DYNAMIC & IMPACTFUL INTERACTIONS
  // ==========================================================================

  // 1. Dynamic Floating Island Dock on Scroll
  const headerNav = document.querySelector('.header-nav');
  const handleNavDock = () => {
    if (window.pageYOffset > 45) {
      headerNav?.classList.add('is-docked');
    } else {
      headerNav?.classList.remove('is-docked');
    }
  };
  window.addEventListener('scroll', handleNavDock, { passive: true });
  handleNavDock();

  // 2. Magnetic Sliding Glider Pill on Navigation Menu
  const navMenu = document.querySelector('.nav-menu-links');
  const glider = document.querySelector('.nav-glider');
  if (navMenu && glider) {
    const navLinks = navMenu.querySelectorAll('.nav-item-link');
    
    const positionGlider = (target) => {
      if (!target) {
        glider.style.opacity = '0';
        return;
      }
      const menuRect = navMenu.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      glider.style.left = `${targetRect.left - menuRect.left}px`;
      glider.style.width = `${targetRect.width}px`;
      glider.style.opacity = '1';
    };

    navLinks.forEach(link => {
      link.addEventListener('mouseenter', () => positionGlider(link));
    });

    navMenu.addEventListener('mouseleave', () => {
      const activeLink = navMenu.querySelector('.nav-item-link.active');
      if (activeLink) {
        positionGlider(activeLink);
      } else {
        glider.style.opacity = '0';
      }
    });

    // Initial placement after layout paints
    setTimeout(() => {
      const activeLink = navMenu.querySelector('.nav-item-link.active') || navLinks[0];
      if (activeLink) positionGlider(activeLink);
    }, 250);
  }

  // 3. Smooth Scroll Spy with Glider Sync
  const sections = document.querySelectorAll('section[id]');
  window.addEventListener('scroll', () => {
    let scrollY = window.pageYOffset;
    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - 140;
      const sectionId = current.getAttribute('id');
      const navItem = document.querySelector(`.nav-menu-links a[href*="${sectionId}"]`);
      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        document.querySelectorAll('.nav-menu-links a').forEach(a => a.classList.remove('active'));
        navItem?.classList.add('active');
      }
    });
  }, { passive: true });

  // 4. Interactive Spotlight Surface Tracking (Linear / Apple 2026 Style)
  const initSpotlightCards = () => {
    const selector = '.spotlight-card, .hero-visual-card, .sector-card, .pillar-card, .hq-office-card, .region-tile, .org-dept-card, .article-brand-card';
    document.querySelectorAll(selector).forEach(card => {
      card.classList.add('spotlight-card');
      card.addEventListener('pointermove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--mouse-x', '-1000px');
        card.style.setProperty('--mouse-y', '-1000px');
      });
    });
  };
  initSpotlightCards();

  // 5. Interactive 3D Perspective Tilt Physics on Key Cards
  const initTiltCards = () => {
    document.querySelectorAll('.tilt-card, .hero-visual-card').forEach(el => {
      el.classList.add('tilt-card');
      el.addEventListener('pointermove', (e) => {
        const rect = el.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.transform = `perspective(1000px) rotateX(${-y * 6.5}deg) rotateY(${x * 6.5}deg) scale3d(1.01, 1.01, 1.01)`;
      });
      el.addEventListener('pointerleave', () => {
        el.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)`;
      });
    });
  };
  initTiltCards();

  // 6. Smooth Animated Number Counters (Eased Interpolation on Scroll)
  const initStatCounters = () => {
    const statItems = [
      { id: 'stat-val-0', target: 2009, prefix: '', suffix: '' },
      { id: 'stat-val-1', target: 6, prefix: '', suffix: '' },
      { id: 'stat-val-2', target: 35, prefix: '', suffix: '+' },
      { id: 'stat-val-3', target: 100, prefix: '', suffix: '%' }
    ];

    let animated = false;
    const statsSection = document.querySelector('.hero-stats-bar');
    if (!statsSection) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !animated) {
          animated = true;
          statItems.forEach(item => {
            const el = document.getElementById(item.id);
            if (!el) return;
            const start = item.target > 1000 ? 1995 : 0;
            const end = item.target;
            const duration = 1800;
            const startTime = performance.now();

            const updateCount = (currentTime) => {
              const elapsed = currentTime - startTime;
              const progress = Math.min(elapsed / duration, 1);
              const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
              const currentVal = Math.round(start + (end - start) * ease);
              el.textContent = `${item.prefix}${currentVal}${item.suffix}`;
              if (progress < 1) {
                requestAnimationFrame(updateCount);
              } else {
                el.classList.add('counter-active');
              }
            };
            requestAnimationFrame(updateCount);
          });
        }
      });
    }, { threshold: 0.3 });

    observer.observe(statsSection);
  };
  initStatCounters();

  // 7. Scroll-Driven Staggered Reveal Animations
  const initScrollReveal = () => {
    const revealElements = document.querySelectorAll('.section-wrapper, .pillar-card, .hq-office-card, .sector-card, .region-tile, .csr-pillar-item, .lead-box');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealElements.forEach(el => {
      el.classList.add('reveal-on-scroll');
      observer.observe(el);
    });
  };
  initScrollReveal();

  // 8. Ambient Liquid Cursor Glow Follower
  const initAmbientCursor = () => {
    if (window.innerWidth < 768) return;
    let glow = document.querySelector('.ambient-cursor-glow');
    if (!glow) {
      glow = document.createElement('div');
      glow.className = 'ambient-cursor-glow';
      document.body.appendChild(glow);
    }

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let currentX = mouseX;
    let currentY = mouseY;

    window.addEventListener('pointermove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    }, { passive: true });

    const renderGlow = () => {
      currentX += (mouseX - currentX) * 0.14;
      currentY += (mouseY - currentY) * 0.14;
      glow.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) translate(-50%, -50%)`;
      requestAnimationFrame(renderGlow);
    };
    renderGlow();
  };
  initAmbientCursor();
});
